import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-573860de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.formatSchedule(_ctx.appointmentData.schedule)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.vet_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.customer_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.pet_name), 1)
    ]),
    (_ctx.considerInsurance)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, [
          _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.pet_policy), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.price), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.appointment_status), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(_ctx.appointmentData.status_date), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["button is-warning is-small", { 'is-loading': _ctx.detailsLoading }]),
          disabled: _ctx.detailsLoading,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.iniAppointmentData(_ctx.appointmentData)))
        }, _toDisplayString(_ctx.$t('General.Details')), 11, _hoisted_3)
      ])
    ])
  ], 64))
}